<template>
  <div class="vehicles-list vehicles-list--layout--account">
    <div class="vehicles-list__body">
      <transition-group name='vehicles'>
        <saved-vehicle-list-item
          v-for="(vehicle, index) in vehiclelist"
          :key="index"
          :index="index"
          :vehicledata="vehicle"
          @remove-vehicle="removeVehicle"
        ></saved-vehicle-list-item>
      </transition-group>
    </div>
  </div>
  <base-dialog
    title="Confirm Delete"
    @close="cancelRemove"
    :open="selectedVehicleIndx != null"
  >
    <template #default>
      <p>Are you sure you want to remove this vehicle?</p>
    </template>
    <template #actions>
      <button
        type="button"
        class="btn btn-sm btn-secondary mr-2"
        @click="cancelRemove"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="confirmRemove"
      >
        Ok
      </button>
    </template>
  </base-dialog>
</template>

<script>
import SavedVehicleListItem from "./SavedVehicleListItem";

export default {
  components: {
    "saved-vehicle-list-item": SavedVehicleListItem,
  },
  props: {
    vehiclelist: {
      type: Array,
      required: true
    }
  },
  emits: ['confirm-remove'],
  data() {
    return {
      selectedVehicleIndx: null,
    };
  },
  methods: {
    removeVehicle(index) {
      this.selectedVehicleIndx = index;
    },
    confirmRemove() {
      // this.vehiclelist.splice(this.selectedVehicleIndx, 1);
      this.$emit("confirm-remove", this.selectedVehicleIndx);
      this.selectedVehicleIndx = null;
    },
    cancelRemove() {
      this.selectedVehicleIndx = null;
    },
  },
};
</script>

<style scoped>
  .vehicles-enter-from {
    opacity: 0;
    transform: translateX(-30px);
  }

  .vehicles-enter-active {
    transition: all 1s ease-out;
  }

  .vehicles-enter-to,
  .vehicles-leave-from {
    opacity: 1;
    transform: translateX(0);
    transform: translateY(0);
  }

  .vehicles-leave-active {
    transition: all .5s ease-in;
    position: absolute;
  }

  .vehicles-leave-to {
    opacity: 0;
    transform: translateY(-50px);
  }

  .vehicles-move {
    transition: transform 0.8s ease;
  }
</style>